(function () {
  'use strict';
  if (window.__tukiAccInit) return;
  window.__tukiAccInit = true;

  function rootUrl() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  function clearDrawerError() {
    var box = document.getElementById('CartDrawer-CartErrors');
    if (box) box.textContent = '';
  }

  /* ---------- Produktmodus: versteckte Formularfelder pflegen ----------
     ⚠️ Hier NUR das Zubehoer eintragen, nie das Hauptprodukt.
     Am 20.08. am Lernturm nachgemessen: /cart/add.js wertet das Feld
     name="id" UND die items[]-Positionen aus. Stand das Hauptprodukt
     zusaetzlich in items[], landete der Lernturm zweimal im Warenkorb
     (einmal aus id samt properties[Lieferzeit], einmal aus items[]).
     Menge und Eigenschaften des Hauptprodukts kommen also weiter aus den
     regulaeren Feldern des Formulars.
     Nicht betroffen: die Bundle-Seiten. Dort raeumt unser eigener
     submit-Handler (#tb-product-form) die Slots ohnehin ab und baut die
     Anfrage als JSON selbst. */
  function slotAttr(value) {
    return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function slotField(name, value) {
    return '<input type="hidden" name="' + slotAttr(name) + '" value="' + slotAttr(value) + '">';
  }

  /* Eine Warenkorbzeile als versteckte Felder. Die Eigenschaften muessen
     direkt hinter id/quantity derselben Position stehen – Shopify (bzw. Rack)
     haengt sie sonst an die falsche items[]-Position. */
  function slotFields(item) {
    var html = slotField('items[][id]', item.id) + slotField('items[][quantity]', item.quantity || 1);
    if (item.properties) {
      Object.keys(item.properties).forEach(function (key) {
        html += slotField('items[][properties][' + key + ']', item.properties[key]);
      });
    }
    return html;
  }

  /* silent = true  -> waehrend der Eingabe: eine angekreuzte Gravur ohne
                        Namen wird einfach weggelassen, nichts wird rot.
     silent = false -> beim Absenden: fehlender Name markiert das Feld und
                        syncSlots() liefert false (Abbruch).
     checkedExtras()/rowItems() stehen weiter unten – Funktionsdeklarationen
     werden gehoistet, der Aufruf hier ist also in Ordnung. */
  function syncSlots(block, silent) {
    var slots = block.querySelector('.tuki-acc__slots');
    if (!slots) return true;

    resolvePersVariant();
    var extras = checkedExtras(block, silent);
    if (extras === null) {
      slots.innerHTML = '';
      return false;
    }

    if (!extras.length) {
      slots.innerHTML = '';
      return true;
    }

    var html = '';
    extras.forEach(function (item) {
      html += slotFields(item);
    });
    slots.innerHTML = html;
    return true;
  }

  /* Kurz vor dem Absenden neu aufbauen – Hauptvariante oder Menge koennen
     nach dem Ankreuzen noch geaendert worden sein. Capture-Phase, damit es
     vor Dawns eigenem submit-Handler laeuft. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.querySelector) return;
      var block = form.querySelector('.tuki-acc--product');
      if (block && syncSlots(block) === false) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  /* ---------- Bildwahl ----------
     Gibt es fuer die Kombination «Zubehoerfarbe x Turmfarbe» ein Bild
     (data-combos an der Zeile, gefuellt aus den Shopify-Dateien), wird das
     genommen. Sonst faellt es auf das normale Variantenbild zurueck. */
  function applyRowImage(row, block) {
    var image = row.querySelector('img.tuki-acc__img');
    if (!image) return;

    var picker = row.querySelector('.tuki-acc__variant');
    var option = picker ? picker.options[picker.selectedIndex] : null;

    var raw = row.getAttribute('data-combos');
    var tower = block ? block.getAttribute('data-tower') : '';
    if (raw && tower) {
      var map;
      try { map = JSON.parse(raw); } catch (e) { map = null; }
      var slug = option ? option.getAttribute('data-slug') : row.getAttribute('data-slug');
      if (map && slug && map[slug] && map[slug][tower]) {
        image.setAttribute('src', map[slug][tower]);
        image.removeAttribute('srcset');
        return;
      }
    }

    if (option) {
      var fallback = option.getAttribute('data-image');
      if (fallback) {
        image.setAttribute('src', fallback);
        image.removeAttribute('srcset');
      }
    }
  }

  function slugify(value) {
    return String(value || '').toLowerCase().trim().replace(/\s+/g, '-');
  }

  /* Turmfarbe hat gewechselt -> alle Zeilen neu bebildern. */
  function setTower(slug) {
    if (!slug) return;
    document.querySelectorAll('.tuki-acc').forEach(function (accBlock) {
      if (accBlock.getAttribute('data-tower') === slug) return;
      accBlock.setAttribute('data-tower', slug);
      accBlock.querySelectorAll('.tuki-acc__row').forEach(function (row) {
        applyRowImage(row, accBlock);
      });
    });
  }

  /* Dawn-Produktseiten: Variantenwechsel des Hauptprodukts. */
  /* Primaerer Weg: direkt am Varianten-Picker.
     Feuert synchron beim Klick statt erst nach Dawns fetch und funktioniert
     auch, falls das Theme den Picker-Typ wechselt. */
  document.addEventListener(
    'change',
    function (event) {
      var picker = event.target && event.target.closest ? event.target.closest('variant-radios, variant-selects') : null;
      if (!picker) return;
      var chosen = picker.querySelector('input[type="radio"]:checked') || picker.querySelector('select');
      if (chosen && chosen.value) setTower(slugify(chosen.value));
    },
    true
  );

  /* Zweiter Weg: Dawns Pub/Sub.
     ⚠️ FALLE (20.08.2026): PUB_SUB_EVENTS ist in assets/constants.js ein
     `const` im globalen Lexical-Scope eines klassischen <script defer>.
     `const` legt KEINE Property auf window an — `window.PUB_SUB_EVENTS` ist
     IMMER undefined. Ein Guard darauf ist immer falsch, das Abo kam nie
     zustande. Dawn selbst nutzt die nackte Referenz. Deshalb hier ebenso. */
  function watchDawnVariant() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var variant = event && event.data && event.data.variant;
          if (variant && variant.title) setTower(slugify(variant.title));
        });
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDawnVariant);
  } else {
    watchDawnVariant();
  }

  /* Bundle-Seiten (sections/tuki-bundle-page.liquid): eigene Farb-Swatches,
     die kein Event ausloesen – deshalb direkt am Klick mitlesen. */
  document.addEventListener('click', function (event) {
    var swatch = event.target.closest ? event.target.closest('.tb-swatch') : null;
    if (!swatch) return;
    var value = swatch.getAttribute('data-color') || swatch.getAttribute('data-value');
    if (value) setTower(slugify(value));
  });


  /* ---------- Variantenwechsel: Bild, Preis, ggf. Formularfeld ----------
     Capture-Phase + stopPropagation, damit Dawns change-Listener auf
     <cart-drawer-items> dieses Event nicht als Mengenaenderung liest. */
  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || !target.classList) return;

      var isPicker = target.classList.contains('tuki-acc__variant');
      var isCheck = target.classList.contains('tuki-acc__check');
      var isPers = target.classList.contains('tuki-acc__pers-check');
      var isPersName = target.classList.contains('tuki-acc__pers-name');
      if (!isPicker && !isCheck && !isPers && !isPersName) return;

      var block = target.closest('.tuki-acc');
      var row = target.closest('.tuki-acc__row');
      if (block && block.getAttribute('data-tuki-acc-mode') === 'cart') event.stopPropagation();

      /* «Mit Namen besticken» an/aus -> Namensfeld ein-/ausblenden. */
      if (isPers && row) {
        var persName = row.querySelector('.tuki-acc__pers-name');
        if (persName) {
          persName.hidden = !target.checked;
          persName.classList.remove('is-error');
          if (target.checked) persName.focus();
        }
        var persHint = row.querySelector('.tuki-acc__pers-missing');
        if (persHint) persHint.hidden = true;
      }

      /* Produktmodus: der Gravur-Block haengt am Haekchen der Zeile. Wird das
         Zubehoer wieder abgewaehlt, setzen wir die Gravur mit zurueck. */
      if (isCheck && row && block && block.getAttribute('data-tuki-acc-mode') === 'product') {
        var persWrap = row.querySelector('.tuki-acc__pers');
        if (persWrap) {
          persWrap.hidden = !target.checked;
          if (!target.checked) {
            var offCheck = persWrap.querySelector('.tuki-acc__pers-check');
            if (offCheck) offCheck.checked = false;
            var offName = persWrap.querySelector('.tuki-acc__pers-name');
            if (offName) {
              offName.hidden = true;
              offName.classList.remove('is-error');
            }
            var offHint = persWrap.querySelector('.tuki-acc__pers-missing');
            if (offHint) offHint.hidden = true;
          }
        }
      }

      if (isPicker && row) {
        var option = target.options[target.selectedIndex];
        if (option) {
          applyRowImage(row, block);
          var newPrice = option.getAttribute('data-price');
          var newFinal = option.getAttribute('data-price-final');
          var oldEl = row.querySelector('.tuki-acc__price-old');
          var nowEl = row.querySelector('.tuki-acc__price-now');
          if (newFinal) {
            if (oldEl) oldEl.textContent = newPrice;
            if (nowEl) nowEl.textContent = newFinal;
          } else if (nowEl && newPrice) {
            nowEl.textContent = newPrice;
          }
        }
      }

      if (block && block.getAttribute('data-tuki-acc-mode') === 'product') syncSlots(block, true);
    },
    true
  );

  /* Tippen im Gravur-Namensfeld: Fehlermarkierung weg, versteckte Felder neu. */
  document.addEventListener('input', function (event) {
    var target = event.target;
    if (!target || !target.classList || !target.classList.contains('tuki-acc__pers-name')) return;
    target.classList.remove('is-error');
    var row = target.closest('.tuki-acc__row');
    var hint = row ? row.querySelector('.tuki-acc__pers-missing') : null;
    if (hint) hint.hidden = true;
    var block = target.closest('.tuki-acc');
    if (block && block.getAttribute('data-tuki-acc-mode') === 'product') syncSlots(block, true);
  });

  /* ---------- Bundle-Seiten: eigener Absende-Weg ----------
     sections/tuki-bundle-page.liquid nutzt ein natives Formular
     (form_type=product, POST auf /cart/add). Zwei Folgen:
     1. Der native Endpunkt wertet NUR das Feld name="id" aus – die
        items[][…]-Felder der Zubehoer-Kaestchen fallen still weg.
     2. Es gibt eine volle Navigation auf die Warenkorbseite statt des
        seitlichen Drawers.
     Deshalb fangen wir hier ab und legen selbst per /cart/add.js an,
     inklusive der Drawer-Sections – dann zeichnet renderContents() den
     Drawer und oeffnet ihn.

     Die Stickerei bauen wir mit ein, statt sie dem Skript der Section
     `starterset_stickerei` zu ueberlassen – das wuerde per window.location
     auf die Warenkorbseite gehen. Weil wir stopPropagation() setzen, kommt
     dessen submit-Handler gar nicht mehr zum Zug; es gibt also genau EINE
     aktive Implementierung. Der Dawn-Zweig des Stickerei-Skripts (Produkte
     mit dem Tag «Personalisierung») bleibt unberuehrt. */
  /* Varianten-ID des Aufpreis-Produkts «Personalisierung:».
     Primaer aus dem Zubehoer-Block (data-pers-variant). Der Block wird aber
     NICHT gerendert, wenn es nichts zu empfehlen gibt – etwa wenn Matte und
     Rutsche schon im Warenkorb liegen. Dann faellt die ID weg, unser Handler
     steigt aus, und das Stickerei-Skript uebernimmt samt Weiterleitung auf
     die Warenkorbseite. Deshalb hier zusaetzlich direkt aus dem Shop holen. */
  var persVariantId = 0;

  function resolvePersVariant() {
    var marker = document.querySelector('[data-pers-variant]');
    if (marker) {
      persVariantId = parseInt(marker.getAttribute('data-pers-variant'), 10) || 0;
    }
    if (!persVariantId && (document.getElementById('tb-pers-check') || document.querySelector('.tuki-acc__pers'))) {
      fetch(rootUrl().replace(/\/$/, '') + '/products/personalisierung.js', { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (product) {
          if (product && product.variants && product.variants[0]) persVariantId = product.variants[0].id;
        })
        .catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resolvePersVariant);
  } else {
    resolvePersVariant();
  }

  function cartUrl() {
    return rootUrl().replace(/\/$/, '') + '/cart';
  }

  /* ---------- Stickerei am Zubehoer ----------
     Wird das Startertuch als Zubehoer gewaehlt, kann es direkt bestickt
     werden. Die Gravur ist eine eigene Warenkorbzeile (Produkt
     «Personalisierung:»), genau wie auf den Set-Seiten – dasselbe
     Property-Format, weil daran die Make-Automatisierung haengt:
       bestickte Zeile : Personalisierung, _personalization_text
       Gravur-Zeile    : _personalization_text, Bestickungsname */
  function engravingOf(row) {
    var wrap = row.querySelector('.tuki-acc__pers');
    if (!wrap) return null;
    var check = wrap.querySelector('.tuki-acc__pers-check');
    if (!check || !check.checked) return null;
    var field = wrap.querySelector('.tuki-acc__pers-name');
    var name = field ? (field.value || '').trim() : '';
    return { name: name, field: field, wrap: wrap };
  }

  function flagMissingName(engraving) {
    if (!engraving) return;
    if (engraving.field) {
      engraving.field.hidden = false;
      engraving.field.classList.add('is-error');
      engraving.field.focus();
    }
    var hint = engraving.wrap.querySelector('.tuki-acc__pers-missing');
    if (hint) hint.hidden = false;
  }

  /* Liefert die Warenkorbzeilen einer angekreuzten Zubehoer-Zeile.
     Gibt null zurueck, wenn eine Gravur angekreuzt ist, aber der Name fehlt. */
  function rowItems(row, fallbackId, silent) {
    var picker = row.querySelector('.tuki-acc__variant');
    var check = row.querySelector('.tuki-acc__check');
    var id = parseInt(
      (picker && picker.value) ||
        (check && check.getAttribute('data-variant-id')) ||
        row.getAttribute('data-variant-id') ||
        fallbackId ||
        0,
      10
    );
    if (!id) return [];

    /* data-pers-quantity: wie viele Tuecher stecken in dieser einen Zeile?
       Die Mengenleiter (snippets/tuki-tuch-menge.liquid) legt bei 2 oder 3
       Tuechern EINE Bundle-Variante an. Die Gravur muss trotzdem pro Tuch
       berechnet werden – genauso wie auf den Duo-/Trio-Seiten, wo
       snippets/trio-stickerei.liquid quantity: n * qty bucht.
       Ohne das Attribut bleibt es bei 1; alle bestehenden Zeilen sind also
       unveraendert. */
    var persQty = parseInt(row.getAttribute('data-pers-quantity'), 10) || 1;

    var item = { id: id, quantity: 1 };
    var engraving = engravingOf(row);
    if (!engraving) return [item];

    if (!engraving.name) {
      if (silent) return [item];
      flagMissingName(engraving);
      return null;
    }
    if (!persVariantId) return [item];

    item.properties = { Personalisierung: engraving.name, _personalization_text: engraving.name };
    return [
      item,
      {
        id: persVariantId,
        quantity: persQty,
        properties: { _personalization_text: engraving.name, Bestickungsname: engraving.name }
      }
    ];
  }

  /* null = Abbruch (fehlender Name) */
  function checkedExtras(block, silent) {
    var out = [];
    if (!block) return out;
    var abort = false;
    block.querySelectorAll('.tuki-acc__row').forEach(function (row) {
      if (abort) return;
      var check = row.querySelector('.tuki-acc__check');
      if (!check || !check.checked) return;
      var items = rowItems(row, 0, silent);
      if (items === null) { abort = true; return; }
      out = out.concat(items);
    });
    return abort ? null : out;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      /* ⚠️ NICHT form.id benutzen! Das Formular enthaelt ein Feld
         <input name="id" id="tb-variant-id">, und benannte Formularfelder
         ueberschreiben gleichnamige Eigenschaften des <form>-Elements.
         `form.id` liefert deshalb dieses INPUT, nicht den String
         'tb-product-form' – der Vergleich war immer ungleich und der ganze
         Handler stieg sofort wieder aus. getAttribute() umgeht das. */
      if (!form || form.getAttribute('id') !== 'tb-product-form') return;

      var accBlock = form.querySelector('.tuki-acc--product');
      var slots = accBlock ? accBlock.querySelector('.tuki-acc__slots') : null;
      if (slots) slots.innerHTML = '';
      resolvePersVariant();
      var extras = checkedExtras(accBlock);
      if (extras === null) {
        /* Gravur angekreuzt, aber kein Name – rowItems() hat das Feld schon
           markiert und fokussiert. Absenden hier abbrechen. */
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      /* Stickerei: wir bauen sie selbst mit ein, statt das Skript der Section
         `starterset_stickerei` uebernehmen zu lassen – das wuerde per
         window.location auf die Warenkorbseite gehen. Das Property-Format
         ist der Vertrag mit der Make-Automatisierung und bleibt exakt so. */
      var persCheck = document.getElementById('tb-pers-check');
      var persName = document.getElementById('tb-pers-name');
      resolvePersVariant();
      var persVariant = persVariantId;
      var withPers = !!(persCheck && persCheck.checked);
      var persValue = withPers && persName ? (persName.value || '').trim() : '';

      if (withPers && !persVariant) return;

      if (withPers && !persValue) {
        event.preventDefault();
        event.stopPropagation();
        var persWrap = document.getElementById('tb-pers-name-wrap');
        var persMissing = document.getElementById('tb-pers-missing');
        if (persWrap) persWrap.style.display = 'block';
        if (persName) { persName.classList.add('tb-pers-error'); persName.focus(); }
        if (persMissing) persMissing.style.display = 'block';
        if (persWrap) persWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var mainInput = form.querySelector('#tb-variant-id');
      var mainId = mainInput ? parseInt(mainInput.value, 10) : 0;
      if (!mainId) return;

      event.preventDefault();
      event.stopPropagation();

      var drawer = document.querySelector('cart-drawer');

      var mainItem = { id: mainId, quantity: 1 };
      var items = [mainItem];
      if (withPers) {
        var props = {};
        new FormData(form).forEach(function (value, key) {
          var match = key.match(/^properties\[(.+)\]$/);
          if (match) props[match[1]] = value;
        });
        props['Personalisierung'] = persValue;
        props['_personalization_text'] = persValue;
        mainItem.properties = props;
        items.push({
          id: persVariant,
          quantity: 1,
          properties: { '_personalization_text': persValue, 'Bestickungsname': persValue }
        });
      }
      items = items.concat(extras);

      var payload = { items: items };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        payload.sections = drawer.getSectionsToRender().map(function (section) { return section.id; });
        payload.sections_url = window.location.pathname;
      }

      var button = form.querySelector('.tb-add-cart');
      if (button) button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return response.json();
        })
        .then(function (result) {
          if (button) button.disabled = false;
          if (accBlock) {
            accBlock.querySelectorAll('.tuki-acc__check').forEach(function (check) { check.checked = false; });
            accBlock.querySelectorAll('.tuki-acc__row').forEach(function (row) {
              row.querySelector('.tuki-acc__check') && row.querySelector('.tuki-acc__check').setAttribute('aria-checked', 'false');
            });
            accBlock.querySelectorAll('.opt, .tuki-acc__row').forEach(function (el) { el.setAttribute('aria-pressed', 'false'); });
          }
          if (drawer && result && result.sections) {
            /* ⚠️ Dawns renderContents() entfernt die Klasse `is-empty` NUR von
               .drawer__inner, nicht vom <cart-drawer>-Element selbst. War der
               Warenkorb beim Seitenaufruf leer, bleibt sie dort stehen – und
               die Theme-CSS setzt dann `visibility: hidden` auf
               <cart-drawer-items>. Ergebnis: Der Drawer geht auf, Summe und
               Zubehoer sind da, aber die Positionen sind unsichtbar, bis man
               neu laedt. Deshalb hier von Hand abraeumen. */
            drawer.classList.remove('is-empty');
            drawer.renderContents(result);
            drawer.classList.remove('is-empty');
          } else {
            window.location.href = cartUrl();
          }
        })
        .catch(function () {
          if (button) button.disabled = false;
          window.location.href = cartUrl();
        });
    },
    true
  );

  /* ---------- Warenkorbmodus: «+» legt sofort in den Warenkorb ---------- */
  function repaintDrawer() {
    return fetch(rootUrl() + '?sections=cart-drawer', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        var type = response.headers.get('content-type') || '';
        if (!response.ok || type.indexOf('json') === -1) return null;
        return response.json();
      })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        if (!html) return false;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer .drawer__inner') || doc.querySelector('.drawer__inner');
        var current = document.querySelector('#CartDrawer .drawer__inner');
        if (!fresh || !current) return false;
        current.innerHTML = fresh.innerHTML;
        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) drawerEl.classList.remove('is-empty');
        clearDrawerError();
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tuki-accessories' });
          }
        } catch (e) {}
        return true;
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest ? event.target.closest('.tuki-acc__add') : null;
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      if (button.classList.contains('is-loading')) return;

      var row = button.closest('.tuki-acc__row');
      if (!row) return;

      /* Im Warenkorbmodus gibt es kein Haekchen – die Varianten-ID steht am
         Knopf. rowItems() haengt eine angekreuzte Gravur als zweite Zeile an
         und liefert null, wenn der Name fehlt. */
      resolvePersVariant();
      var items = rowItems(row, button.getAttribute('data-variant-id'));
      if (items === null) return;
      if (!items.length) return;

      button.classList.add('is-loading');
      clearDrawerError();

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return response.json();
        })
        .then(function () { return repaintDrawer(); })
        .then(function (ok) { if (!ok) window.location.reload(); })
        .catch(function () { button.classList.remove('is-loading'); });
    },
    true
  );
})();
